var Promise = require('bluebird');
var svgSize = require('./svgSize.js');

function getSvg(filename) {
	return new Promise(function (resolve, reject) {
		$.ajax({
				url: '/images/out_svg/' + filename,
				dataType: 'html'
			})
			.done(function (svg) {
				resolve(svg);
			})
			.fail(function (error) {
				reject(error);
			});
	});
}

export function addSvg() {
	return new Promise(function (resolve, reject) {
		$('.graphic [data-svg]')
			.each(function () {
				var $svgDiv = $(this);
				var filename = $svgDiv.attr('data-svg');
				var pngfilename = filename.replace('.svg', '.png');
				getSvg(filename)
					.then(function (svg) {
						$svgDiv.html('<!--[if gt IE 8]>-->' + svg + '<!--<![endif]-->');
						$svgDiv.append('<!--[if lt IE 9]><img src="/images/out_png/' + pngfilename + '"><![endif]-->');

						var $svg = $svgDiv.find('svg');
						svgSize.fitSvgSizeToWidth($svgDiv, $svg);
						return $svg;
					})
					.then(resolve);
			});
	});
}

// Promise, срабатывающий после отрисовки
module.exports.addSvgPromise = addSvg();



/** WEBPACK FOOTER **
 ** ./frontend/components/svg/svg.js
 **/